module.exports = __webpack_public_path__ + "img/Keks_pay.72da5c83.svg";